module.exports = __webpack_public_path__ + "static/media/alert-icon.c84ca0c3.svg";